import { Component } from '@angular/core';
import { CallService } from '../../../services/call.service';

@Component({
  selector: 'app-call-status-badge',
  templateUrl: './call-status-badge.component.html',
  styleUrls: ['./call-status-badge.component.scss']
})
export class CallStatusBadgeComponent {
  callState$ = this.callService.callState$;
  role = localStorage.getItem('role');

  constructor(private callService: CallService) {}
}
